<template>
  <div
    style="
      display: flex;
      min-height: 100vh;
      padding: 30px 0;
      align-items: center;
      justify-content: center;
    "
  >
    <div class="container">
      <div class="banner">
        <figure style="margin-bottom: 50px">
          <img
            src="assets/404.webp"
            style="max-width: 820px; max-height: 460px; margin: 0 auto"
          />
        </figure>
        <div class="banner-content text-center">
          <span
            class="btn btn-dark btn-rounded btn-icon-right"
            @click="to_index"
          >
            {{ $yuyanbao.shouye }}
            <i class="w-icon-long-arrow-right"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page404",
  methods: {
    to_index() {
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>
